export enum ReferenceNumberType {
  Booking = 'booking',
  Redelivery = 'redelivery',
  VendorRelease = 'vendor_release',
  Pickup = 'pickup',
}
